module.exports = __webpack_public_path__ + "images/assets/42724ba212ba45200dafb0a24d8e9b02.svg";